import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import { LocationsDTO } from 'models'
import api from './api'

const { ENDPOINT_VIAMUNICIPIO } = environments

export const getMunicipio = async (
    UF: string
): Promise<AxiosResponse<LocationsDTO[]>> => {
    return await api.get(`${ENDPOINT_VIAMUNICIPIO}/localidades/${UF}`)
}
